import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';

// Ported 1:1 from the prototype `.search` (search input with a leading magnifier icon).
export const styles = {
  wrap: {
    kVAEAm: "x1n2onr6",
    ks0D6T: "x1va8c73",
    kUk6DE: "x98rzlu",
    $$css: true
  },
  icon: {
    kVAEAm: "x10l6tqk",
    kbCHJM: "x1c5ba64",
    k87sOh: "xwa60dl",
    k3aq6I: "x1cb1t30",
    kzqmXN: "x1kky2od",
    kZKoxP: "xlup9mm",
    kMwMTN: "xdxw5r1",
    kfzvcC: "x47corl",
    $$css: true
  },
  input: {
    kZKoxP: "x16wdlz0",
    kzqmXN: "xh8yej3",
    kWkggS: "x13uruat",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    kaIpWk: "xxltkoq",
    kE3dHu: "x17v3rxn",
    kpe85a: "x1sw23gd",
    kMwMTN: "x1oezkus",
    kMv6JI: "xdv2sak",
    kGuDYH: "x2pyw9z",
    kI3sdo: "x1a2a7pz",
    kmkexE: "x1k3q35m",
    k8Qsv1: "x1l9ba8j",
    k4mVRr: "xwo1ljg",
    kWEjV4: "xs8x3o8",
    $$css: true
  },
  inputSunken: {
    kWkggS: "x16vpd03",
    $$css: true
  }
};